import React from 'react';
import { MusicIcon } from 'lucide-react';
const situations = [{
  title: 'Non sono un musicista',
  text: 'Devi insegnare musica ma non hai una formazione specifica, e hai paura di sbagliare i contenuti.'
}, {
  title: 'Zero tempo per preparare',
  text: 'Tra programmazioni, verifiche e burocrazia, non ti resta tempo per creare materiali musicali da zero.'
}, {
  title: 'Materiali sparsi e incoerenti',
  text: "Fogli trovati online, livelli sbagliati, nessuna progressione reale da un anno all'altro."
}];
export function Recognize() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-154" data-mp="2d7dp7exjnfsl">
      <div className="mx-auto max-w-5xl" data-id="element-155" data-mp="2d7vsuwmjcwaj">
        <h2 className="flex items-center justify-center gap-3 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-156" data-mp="288sq5iu1325q">
          <MusicIcon className="h-6 w-6 flex-none text-grape sm:h-7 sm:w-7" aria-hidden="true" data-id="element-157" data-mp="bfqtj02piwps" />
          Ti Riconosci in Queste Situazioni?
        </h2>
        <p className="mt-4 text-center text-base text-ink-soft sm:text-lg" data-id="element-158" data-mp="3jlbx8v98pgyh">
          Non sei solo/a. La maggior parte degli insegnanti di musica vive esattamente questo.
        </p>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-159" data-mp="39mw64sa7q7oz">
          {situations.map((item, index) => <li key={item.title} className="grid grid-rows-[auto_auto_1fr] rounded-3xl border border-navy/10 bg-white p-6" data-id="element-160" data-mp="3elh6crpgsrdf" data-mpi={index}>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy-tint text-sm font-bold text-navy" data-id="element-161" data-mp="68a6r33wz7r9">
                {index + 1}
              </span>
              <h3 className="mt-4 text-lg font-bold text-navy" data-id="element-162" data-mp="3sl8qla6kr3zv">{item.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-163" data-mp="1efjjpp3oanf">{item.text}</p>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-base font-semibold text-orange sm:text-lg" data-id="element-164" data-mp="p2yp3xgrm9bt">
          E meriti molto di più di questo.
        </p>
      </div>
    </section>;
}